export enum ROLES {
  SUPER_ADMIN = "super-admin",
  ADMIN = "admin",
  USER = "user",
  EMPLOYEES = "employees",
}
